module.exports = __webpack_public_path__ + "UCF-9803bf6bc0eebd5ae01050c238402635.png";